import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
export const Route = createFileRoute("/about")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "About Us | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Meet the Neuro Wellness TMS team in Coral Springs, FL. Board-certified psychiatrists specializing in SAINT TMS, SPRAVATO, and treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "About Us | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Meet the Neuro Wellness TMS team in Coral Springs, FL. Board-certified psychiatrists specializing in SAINT TMS, SPRAVATO, and treatment-resistant depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/about",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/about",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <About />;
}
